<template>
  <button type="button" class="btn-main">
    <i v-if="icon" :class="icon" />
    <span v-if="icon" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "MainButton",
  props: ["label", "icon"],
};
</script>